import { h } from "preact";
import Required from "./Required";
import Description from "./Description";
import ImageUpload from "../ImageUpload";

const ImageUploadField = ({
  input,
  label,
  description,
  inputType,
  required,
  type,
  style,
  aspectRatio,
  meta: { touched, error, warning }
}) => {
  inputType = inputType ? inputType : type;
  return (
    <div
      class={touched && error ? "form-group has-error" : "form-group"}
      style={style}
    >
      {label ? (
        <label for={input.name} class="form-label">
          {label}
          <Required required={required} />
        </label>
      ) : (
        ""
      )}
      <Description description={description} />
      <ImageUpload {...input} aspectRatio={aspectRatio} />
      {touched && error && <p class="form-input-hint">{error}</p>}
    </div>
  );
};

export default ImageUploadField;



// WEBPACK FOOTER //
// ./components/fields/ImageUploadField.js